module.exports = __webpack_public_path__ + "static/img/感知测试_0.bffdeda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/感知测试_0.jpg
// module id = K0Gv
// module chunks = 1